import api from "./api";

/**
 * Audit service for audit log endpoints
 * All endpoints require SUPER_ADMIN role
 */

/**
 * Get login audit logs
 * Query params: user_id, email, success, from_date, to_date, page, limit
 */
export async function getLoginLogs(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.user_id) queryParams.append("user_id", params.user_id);
  if (params.email) queryParams.append("email", params.email);
  if (params.success !== undefined && params.success !== null) {
    queryParams.append("success", params.success);
  }
  if (params.from_date) queryParams.append("from_date", params.from_date);
  if (params.to_date) queryParams.append("to_date", params.to_date);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const query = queryParams.toString();
  return api.get(`/audit/logins${query ? `?${query}` : ""}`);
}

/**
 * Get CREATE / UPDATE / DELETE action logs
 * Query params: user_id, entity_type, entity_id, action, from_date, to_date, page, limit
 */
export async function getActionLogs(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.user_id) queryParams.append("user_id", params.user_id);
  if (params.entity_type) queryParams.append("entity_type", params.entity_type);
  if (params.entity_id) queryParams.append("entity_id", params.entity_id);
  if (params.action) queryParams.append("action", params.action);
  if (params.from_date) queryParams.append("from_date", params.from_date);
  if (params.to_date) queryParams.append("to_date", params.to_date);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const query = queryParams.toString();
  return api.get(`/audit/actions${query ? `?${query}` : ""}`);
}

/**
 * Get all audit logs for a specific user
 * Path param: id (user ID)
 * Query params: page, limit
 */
export async function getUserAuditLogs(userId, params = {}) {
  if (!userId) throw new Error("User ID is required");

  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const query = queryParams.toString();
  return api.get(`/audit/user/${userId}${query ? `?${query}` : ""}`);
}

/**
 * Get failed login attempts
 * Query params: hours (default: 24), page, limit
 */
export async function getFailedLogins(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.hours) queryParams.append("hours", params.hours);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const query = queryParams.toString();
  return api.get(`/audit/failed-logins${query ? `?${query}` : ""}`);
}

/**
 * Get DELETE operations within a time window
 * Query params: hours (default: 24), page, limit
 */
export async function getDeletions(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.hours) queryParams.append("hours", params.hours);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const query = queryParams.toString();
  return api.get(`/audit/deletions${query ? `?${query}` : ""}`);
}
